import Vue from 'vue';
// import * as constants from '../constants';

// const nms = [ constants.NAMESPACE, 'store', 'mutations' ].join('/');
// const log = require('debug')('@mycure/vue-plugins/' + nms);

/// imports and local declarations
/**
 * @typedef {import('./state').default} State
 * @typedef {import('./state').SMSMessage} SMSMessage
 */

/**
 * @param {State} state
 * @param {SMSMessage[]} obj
 */
export function setSMSMessages (state, obj) {
  state.messages = obj || [];
}

/**
 * @param {State} state
 * @param {Object} obj
 * @param {boolean} [obj.upsert=true]
 * @param {SMSMessage[]} obj.items
 */
export function updateInSMSMessages (state, obj) {
  const { items, upsert } = obj;
  const list = state.messages;
  items.forEach(item => {
    // find existing
    const index = list.findIndex(i => i.id === item.id);

    // update existing (inherit patient details)
    if (~index) {
      return Vue.set(list, index, item);
    }

    // add to list
    if (upsert) list.push(item);
  });
}
